/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { object, func, shape, bool } from 'prop-types';
import { connect } from 'react-redux';

import { setPaymentMethodStatus as setPaymentMethodStatusAction } from 'actions/paymentMethod';

import { STATUS } from 'reducers/paymentMethod';

import SelectMethod from './SelectMethod/SelectMethod';
import RegisterCompany from './RegisterCompany/RegisterCompany';
import CreateCompany from './CreateCompany/CreateCompany';
import RegisterCoolCompany from './RegisterCoolCompany/RegisterCoolCompany';
import RegisterFreelance from './RegisterFreelance/RegisterFreelance';
import ViewPaymentMethod from './ViewPaymentMethod/ViewPaymentMethod';

/**
 * This is the PaymentMethod component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class PaymentMethod extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: shape({
      has_payment_method: bool.isRequired,
    }).isRequired,
    paymentMethod: object.isRequired,
    setPaymentMethodStatus: func.isRequired,
  };

  componentDidMount() {
    const {
      user: { has_payment_method },
      setPaymentMethodStatus,
    } = this.props;

    // Reset payment when change location.
    const paymentStatus = has_payment_method
      ? STATUS.HAS_PAYMENT_METHOD
      : STATUS.SELECT_METHOD;

    setPaymentMethodStatus(paymentStatus);
  }

  renderStep() {
    const { paymentMethod } = this.props;

    switch (paymentMethod.status) {
      case STATUS.REGISTER_COMPANY:
        return <RegisterCompany />;

      case STATUS.CREATE_COMPANY:
        return <CreateCompany />;

      case STATUS.REGISTER_FREELANCE:
        return <RegisterFreelance />;

      case STATUS.REGISTER_COOL_COMPANY:
        return <RegisterCoolCompany />;

      case STATUS.HAS_PAYMENT_METHOD:
        return <ViewPaymentMethod />;

      default:
        return <SelectMethod onSubmit={this.onSubmitMethod} />;
    }
  }

  onSubmitMethod = data => {
    const { setPaymentMethodStatus } = this.props;
    const { country, company } = data;

    if (company === 'YES') {
      return setPaymentMethodStatus(STATUS.REGISTER_COMPANY);
    }

    if (company === 'NO' && country === 'SE') {
      return setPaymentMethodStatus(STATUS.REGISTER_COOL_COMPANY);
    }

    return setPaymentMethodStatus(STATUS.REGISTER_FREELANCE);
  };

  /**
   * Render PaymentMethod.
   *
   * @return {Object}
   */
  render() {
    return this.renderStep();
  }
}

export default connect(
  ({ user, paymentMethod }) => ({ user, paymentMethod }),
  {
    setPaymentMethodStatus: setPaymentMethodStatusAction,
  }
)(PaymentMethod);
